const ExploreNearData27 = [
  {
    title: "The Spa at La Costa",
    description: `Book a massage, facial, or body treatment at the resort's full-service spa, which also has an outdoor pool and a café exclusive to spa guests. Call (760) 438-9111, extension 5, to make a reservation — appointments fill up fast!`,
    distance: 0,
  },
  {
    title: "Resort Pools",
    description: `Choose from four pool areas: the adults-only Edge Pool, the two Garden Pools and hot tubs (with cornhole, giant Jenga, and ping-pong), the quiet Villa Pool, and the Splash Pool, which has two 100-foot waterslides and a splash pad (riders must be 48" tall, or 42–47" with a life vest).`,
    distance: 0,
  },
  {
    title: "North & South Golf Courses",
    description: `Tee off at either of the resort's two championship, 18-hole courses. The North Course underwent a 2024 Gil Hanse redesign and now hosts the NCAA Division I Golf Championships. Resort guests can book tee times up to 90 days in advance by calling the pro shop at (760) 931-7595.`,
    distance: 0,
  },
  {
    title: "Tennis & Pickleball",
    description: `The resort runs a world-class tennis program managed by Cliff Drysdale Tennis, plus one-hour pickleball clinics for beginners followed by open play sessions. Reservations are recommended for both — call (760) 931-7501 to book.`,
    distance: 0,
  },
  {
    title: "Little Sprouts Kids Camp",
    description: `Counselor-supervised programming for children ages six months to 12 years, daily 8 AM to 4 PM, with night camp available on Wednesday and Thursday evenings.`,
    distance: 0,
  },
  {
    title: "Athletic Club & Fitness Classes",
    description: `The 9,100-square-foot Athletic Club is open 24 hours with personal trainers available. Complimentary fitness classes run weekly, including body sculpting, spin, Zumba, boot camp, and more. Be sure to check the resort's schedule when you arrive.`,
    distance: 0,
  },
  {
    title: "Bike Rentals",
    description: `Rent a standard, cruiser, or electric bike by the hour at Hello, Sunshine!, near the valet drive for an easy, breezy way to explore the 400-acre grounds.`,
    distance: 0,
  },
  {
    title: "Beach Shuttle",
    description: `The resort runs a complimentary guest shuttle to Carlsbad Village and Moonlight Beach three times daily: 9:30 AM, 10:30 AM, and 12 PM. Reservations are required at the bell desk.`,
    distance: 0,
  },
  {
    title: "The Shops of La Costa",
    description: `The resort features a small plaza of charming on-property boutiques, including Hello, Sunshine!, LiveWell Kids, Coastal Dunes, and Buttercup.`,
    distance: 0,
  },
  {
    title: "On-Property Dining",
    description: `Options range from casual to special-occasion: Marketplace (grab-and-go and coffee), VUE (brunch and dinner with patio views), Bar Traza (Spanish-inspired shared plates), Bob's Steak & Chop House (reservations recommended), plus poolside spots like Splash Café, Edge Bar, Tiki Social, and Garden Pool.
    <ul>
    <li>Kids age 10 and under eat free off the Junior Chef menu for breakfast and lunch.</li>
    <li>Kids eat 50% off dinner with the purchase of one adult entree at Bar Traza and VUE (dine-in only).</li>
    </ul>`,
    distance: 0,
  },
  {
    title: "Pet-Friendly Perks",
    description: `Omni La Costa is a dog-friendly resort! There's a one-time $75 fee per reservation (or $200 for suites and villas), and leashed pups are welcome at outdoor dining areas. Check the full pet policy before booking.`,
    distance: 0,
  },
];

export default ExploreNearData27;
